<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-spacer></v-spacer>
      <v-col sm="3">
        <v-layout row wrap class="mt-2 ml-2">
          <v-flex xs5>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  dense
                  class="text1"
                  v-model="date1Formatted"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date1"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs5 ml-2>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="text2"
                  v-model="date2Formatted"
                  outlined
                  dense
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs1 class="ml-1">
            <v-btn small color="#112A46" dark height="38px" @click="getComments"
              >Go</v-btn
            >
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
    <v-row
      v-if="comments.length == 0"
      align="center"
      class="text-center"
      style="min-height:200px;"
    >
      <v-col>
        <h1 class="display-2 grey--text" style="text-align:center">
          No Comment Found
        </h1>
      </v-col>
    </v-row>
    <v-row v-else style="min-height:420px;">
      <v-col cols="3" xl="3" lg="4" md="4" sm="4" v-for="(data, index) in comments" :key="index">
        <v-card  style="border-radius: 5px 5px 0 0; " class="rounded-2 shadow-2">
          <div style="position: absolute; top:1px; right:1px;">
            <v-card-text class="pa-2">
              <v-chip x-small color="success" v-if="data.status_id == 1">
                Live
              </v-chip>
              <v-chip x-small color="error" v-else-if="data.status_id == 2">
                Deleted
              </v-chip>
            </v-card-text>
          </div>
          <v-row @click="getCommentDetails(data.id)">
            <v-col cols="12" style="height:100px">
              <v-card-text
                class="px-4 "
                style="overflow: hidden;
                      display: -webkit-box;
                      font-size: 16px;
                      font-weight: 600;
                      -webkit-line-clamp: 3;
                      -webkit-box-orient: vertical;"
                >{{ data.comment }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-card style="width:100%; background: #fff" elevation="0" class="rounded-2 shadow-2">
            <v-row>
              <v-col cols="12" class="py-0">
                <v-list-item-icon class="mt-3 mb-3 ml-3">
                  <SvgIcon>
                    <template #icon>
                      <CalendarIcon></CalendarIcon>
                      {{ data.created_date | dayDateFormat }} - {{ data.created_time | timeFormat }}
                    </template>
                  </SvgIcon>
                </v-list-item-icon>
              </v-col>
            </v-row>
            <v-row class="ml-2 mt-2 mb-2">
              <v-col md="3">
                <v-btn

                    elevation="0"
                    :color="data.status_id == 2 ? 'success' : 'error'"
                    style="background: white"
                    outlined
                    @click="
                    data.status_id == 2
                      ? toggleStatus(data.id, 1)
                      : toggleStatus(data.id, 2)
                  "
                    dark
                    class="w-full"
                >
                  <v-list-item-icon class="my-0" style="margin: auto">
                    <SvgIcon v-if="data.status_id == 1">
                      <template #icon >
                        <DeleteIcon></DeleteIcon>
                      </template>
                    </SvgIcon>

                    <SvgIcon v-if="data.status_id == 2">
                      <template #icon >
                        <ActivateIcon></ActivateIcon>
                      </template>

                    </SvgIcon>
                  </v-list-item-icon>
                </v-btn>
              </v-col>
              <v-col md="8">

                <v-btn
                    elevation="0"
                    color="#008483"
                    @click="showPostModel(data.post_id)"
                    dark
                    class="w-full"
                >View Post
                </v-btn
                >
              </v-col>

            </v-row>
          </v-card>
          <!-- </v-col> -->
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="commentsDialog" width="500">
      <v-row style="min-height:420px;">
        <v-col cols="12" sm="12" class="pa-0 ml-3 mt-6">
          <v-card
            color="#f2f2f2"
            style="border-radius: 5px 5px 0px 0px; "
            height="400px"
          >
            <div style="position: absolute; top:1; right:0; left:1">
              <v-card-text class="pa-2">
                <v-chip
                  x-small
                  color="success"
                  v-if="commentDetails.status_id == 1"
                >
                  Live
                </v-chip>
                <v-chip
                  x-small
                  color="error"
                  v-else-if="commentDetails.status_id == 2"
                >
                  Deleted
                </v-chip>
              </v-card-text>
            </div>
            <!-- <v-col cols="12"> -->
            <v-row>
              <v-col cols="12" style="height:300px" class="pa-0 ml-0">
                <v-card-text class="px-4"
                  >{{ commentDetails.comment }}
                </v-card-text>
              </v-col>
              <!-- <v-col cols="4">
                <v-card-text>
                  <v-chip class="ma-2" color="primary">
                    Primary
                  </v-chip>
                </v-card-text>
              </v-col> -->
            </v-row>
            <v-card style="width:100%; background: #fff" elevation="0">
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-list-item-icon class="mt-3 mb-3 ml-3">
                    <v-icon small class="mr-2">mdi-calendar</v-icon
                    >{{ commentDetails.created_date }}
                  </v-list-item-icon>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-list-item-icon class="mt-3 mb-3 ml-3">
                    <v-icon small class="mr-2">mdi-clock-outline</v-icon
                    >{{ commentDetails.created_time }}
                  </v-list-item-icon>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-btn
                    small
                    elevation="0"
                    color="#008483"
                    tile
                    @click="showPostModel(commentDetails.post_id)"
                    dark
                    class="ma-1"
                    width="100%"
                    >View Post</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
            <!-- </v-col> -->
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
    <post-model v-bind="postModel" @close="postModel.postID = null" />

    <v-pagination v-model="page" :length="totalPages"></v-pagination>
  </v-container>
</template>

<script>
import PostModel from "./../../Feeds/Post/PostModel";
import moment from "moment";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import ActivateIcon from "@/assets/images/misc/unlock.svg";
import DeleteIcon from "@/assets/images/misc/delete.svg";
import CalendarIcon from "@/assets/images/misc/calendar.svg";
export default {
  data() {
    return {
      comments: [],
      commentDetails: [],
      page: 1,
      commentsDialog: false,
      perPage: null,
      totalPages: 1,
      postID: null,
      date1: moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      menu1: false,
      menu2: false,
      search: null,
      postModel: { postID: null, type: "details" },
    };
  },
  components: {
    ActivateIcon, SvgIcon,CalendarIcon,
    PostModel,DeleteIcon,
  },
  props: {
    userID: { type: Number },
  },
  mounted() {
    this.getComments();
  },
  watch: {
    userID() {
      this.page = 1;
      this.getComments();
    },
    page() {
      this.getComments();
    },
    search() {
      this.page = 1;
      this.getComments();
    },
  },
  computed: {
    date1Formatted() {
      return moment(this.date1, "YYYY-MM-DD").format("Do MMM YYYY");
    },
    date2Formatted() {
      return moment(this.date2, "YYYY-MM-DD").format("Do MMM YYYY");
    },
  },
  methods: {
    showPostModel(postId) {
      this.postModel.postID = parseInt(postId);
      this.postModel.type = "details";
    },
    getComments() {
      this.showLoader('Loading');
      let url =
        "&per_page=6&page=" +
        this.page +
        "&from_date=" +
        this.date1 +
        "&end_date=" +
        this.date2;
      if (this.search != null && this.search != "") {
        url += "&term=" + this.search;
      }
      this.$http
        .get("admin/user-comments?user_id=" + this.userID + url)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.comments = response.data.data;
            this.totalPages = response.data.total_pages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        }).finally(() => {
            this.hideLoader()
      });
    },
    getCommentDetails(id) {
      this.$http
        .get("admin/user-comment-details/" + id)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.commentDetails = response.data.data;
            this.commentsDialog = true;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    toggleStatus(id, status_id) {
      this.$http
        .put(`admin/delete-comment/` + id + `/` + status_id)
        .then((response) => {
          if (response.status == 200) {
            this.getComments();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
  },
};
</script>

<style></style>
